import { render, staticRenderFns } from "./Nutrition_status.vue?vue&type=template&id=3f1ca7b0&scoped=true&"
import script from "./Nutrition_status.vue?vue&type=script&lang=js&"
export * from "./Nutrition_status.vue?vue&type=script&lang=js&"
import style0 from "./Nutrition_status.vue?vue&type=style&index=0&id=3f1ca7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ca7b0",
  null
  
)

export default component.exports